import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiErrorHandler from '../services/apiErrorHandler';

export default function ApiErrorHandlerInit() {
  const navigate = useNavigate();
  React.useEffect(() => {
    try {
      apiErrorHandler.initialize((path: string) => navigate(path));
    } catch {}
  }, [navigate]);
  return null;
}
